import {createSelector, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface DescribeKinshipSurveyInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    editId: string,
    editTitle: string,
    editMultiple: 0 | 1,
    editActive: 0 | 1,
    editAnswers: {
        title: string;
        active: 0 | 1;
    }[],
    deleteModalVisible: boolean,
    deleteId: string,
}

function getInitialState(): DescribeKinshipSurveyInterface {
    return {
        formVisible: false,
        formVariant: "new",
        editId: "",
        editTitle: "",
        editMultiple: 0,
        editActive: 1,
        editAnswers: [
            {
                title: "",
                active: 1,
            }
        ],
        deleteId: "",
        deleteModalVisible: false,
    }
}

export const DescribeKinshipSurveySlice = createSlice({
    name: "DescribeKinshipSurveySlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => {
            return getInitialState()
        },
        updateFields: (state, action: PayloadAction<Partial<DescribeKinshipSurveyInterface>>) => {
            Object.assign(state, action.payload)
        }
    },
});

export const {
    reset,
    updateFields
} = DescribeKinshipSurveySlice.actions;

export const DescribeKinshipSurveySelectors = {
    formVisible: (state: RootState) => state.describeKinshipSurvey.formVisible,
    formVariant: (state: RootState) => state.describeKinshipSurvey.formVariant,
    editId: (state: RootState) => state.describeKinshipSurvey.editId,
    editTitle: (state: RootState) => state.describeKinshipSurvey.editTitle,
    editMultiple: (state: RootState) => state.describeKinshipSurvey.editMultiple,
    editActive: (state: RootState) => state.describeKinshipSurvey.editActive,
    editAnswers: (state: RootState) => state.describeKinshipSurvey.editAnswers,
    deleteModalVisible: (state: RootState) => state.describeKinshipSurvey.deleteModalVisible,
    deleteId: (state: RootState) => state.describeKinshipSurvey.deleteId,
    formState: createSelector(
      (state: RootState) => state.describeKinshipSurvey,
      (formState) => ({
          formVisible: formState.formVisible,
          formVariant: formState.formVariant,
          editId: formState.editId,
          editTitle: formState.editTitle,
          editMultiple: formState.editMultiple,
          editActive: formState.editActive,
          editAnswers: formState.editAnswers,
      })
    )
}


export const DescribeKinshipSurveyReducer = DescribeKinshipSurveySlice.reducer;
